import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

function DepartmentCard(props) {
    return (
        <div className="col-lg-6 col-md-6 wow fadeInUp" data-wow-delay={props.delay}>
            <div className="box">
                <div className="icon">
                    <FontAwesomeIcon icon={props.icon} />
                </div>
                <h4 className="title">{props.name}</h4>
                <p className="description">{props.description}</p>
                <p><strong>Líderes: </strong>{props.coordinators}</p>
            </div>
        </div>
    );
}

export default DepartmentCard;